export const siteSettings = {
  name: "Probitstrade",
  link: "https://protrades.live",
  email: "support@protrades.live",
  appLink: "https://app.protrades.live",
};
